require('offline-plugin/runtime').install();



// WEBPACK FOOTER //
// ./lib/offline-sw.js